
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 34.2 34.2","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"17.1","cy":"17.1","fill":"#bdccd4","r":"17.1"}}),_c('g',{attrs:{"fill":"#1d1e35"}},[_c('path',{attrs:{"d":"M11.78 14.05H7.53a.47.47 0 00-.47.47v5.17c0 .26.21.47.47.47h4.25c1.11 0 2.2.23 3.21.68l2.79 1.23c.37.16.79-.11.79-.51v-8.9c0-.41-.42-.68-.79-.51l-2.79 1.23c-1.01.44-2.1.67-3.21.67zM19.51 22.33c2.88 0 5.23-2.34 5.23-5.23s-2.34-5.23-5.23-5.23c-.07 0-.12.06-.12.12v1c0 .07.06.12.12.12 2.19 0 3.98 1.78 3.98 3.98 0 2.19-1.78 3.98-3.98 3.98-.07 0-.12.06-.12.12v1c0 .08.05.14.12.14z"}}),_c('path',{attrs:{"d":"M19.51 24.73c4.21 0 7.63-3.42 7.63-7.63s-3.42-7.63-7.63-7.63c-.07 0-.12.06-.12.12v1c0 .07.06.12.12.12 3.52 0 6.38 2.86 6.38 6.38s-2.86 6.38-6.38 6.38c-.07 0-.12.06-.12.12v1c0 .08.05.14.12.14z"}})])])
          )
        }
      }
    